import { atom, useAtomValue, useSetAtom } from 'jotai';
import { useCallback } from 'react';

type DrawerData = {
  type: 'qrCode';
  url: string;
  titleKey?: string;
};

const drawerState = atom<{
  visible: boolean;
  data: DrawerData;
}>({
  visible: false,
  data: { type: 'qrCode', url: '' }
});

export const useDrawerState = () => {
  return useAtomValue(drawerState);
};

export const useDrawer = () => {
  const set = useSetAtom(drawerState);
  const open = useCallback((data: DrawerData) => set({ visible: true, data }), [
    set
  ]);
  const close = useCallback(
    () => set((data) => ({ ...data, visible: false })),
    [set]
  );
  return { open, close };
};
